<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'

const props = defineProps({
  options: {
    type: Array as () => Array<{ label: string; value: any }>,
    default: () => []
  },
  modelValue: {
    type: Array as () => any[],
    default: () => []
  },
  readOnly: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const values = ref([...props.modelValue])
const openPanel = ref(false)
const containerRef = ref<HTMLElement | null>(null)
const readOnly = computed(() => props.readOnly)

// Sync when modelValue changes from outside
watch(() => props.modelValue, (newVal) => {
  values.value = [...newVal]
})

// Emit when user selects/deselects
const toggleValue = (val: any) => {

  const index = values.value.indexOf(val)

  if (index >= 0) {
    values.value.splice(index, 1)
  } else {

    values.value.push(val)
  }
  emit('update:modelValue', [...values.value])
}

const handleTogglePanel = () => {
  openPanel.value = !openPanel.value
}

const handleClickOutside = (event: MouseEvent) => {
  if (containerRef.value && !containerRef.value.contains(event.target as Node)) {
    openPanel.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
  <div class="filter-select-multiple" ref="containerRef">
    <div class="filter-select-multiple__header">
      <div
        class="item"
        v-for="(val, index) in values"
        :key="`selected-${index}`"
      >
        <div class="value">
          {{ options.find(opt => opt.value === val)?.label || val }}
        </div>
        <div class="icon" @click.stop="toggleValue(val)" v-if="!readOnly">
          <Icon icon="material-symbols:close"/>
        </div>
      </div>

      <div class="item add" @click="handleTogglePanel" v-if="!readOnly">
        <div class="value">Chọn</div>
        <div class="icon">
          <Icon icon="formkit:add"/>
        </div>
      </div>
    </div>

    <div :class="`filter-select-multiple__content ${openPanel ? 'open' : ''}`" v-if="!readOnly">
      <h4>Các lựa chọn</h4>
      <div class="options">
        <div
          v-for="(option, index) in options"
          :key="`optionItem${index}`"
          :class="`option-item ${values.includes(option.value) ? 'active' : ''}`"
          @click="toggleValue(option.value)"
        >
          <Icon
            :icon="values.includes(option.value) ? 'akar-icons:check-box' : 'proicons:checkbox-unchecked'"
            width="24" height="24"
          />
          <div class="label">{{ option.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
